import React from "react";
import { ManageVersionsComponent } from "../../../components/manage-versions-components";

export const ManageVersionsPage: React.FC = () => {
    return <ManageVersionsComponent />;
};
